import React from 'react';

const SafetyVisualization = () => {
  return (
    <div className="w-full relative overflow-hidden rounded-lg bg-gradient-to-br from-slate-900 to-slate-800 border border-yellow-500/20" style={{ height: '500px', minHeight: '400px' }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 800 320"
        className="absolute inset-0"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <linearGradient id="safeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="rgba(16, 185, 129, 0.15)" />
            <stop offset="100%" stopColor="rgba(16, 185, 129, 0.05)" />
          </linearGradient>
          
          <linearGradient id="warningGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="rgba(245, 158, 11, 0.2)" />
            <stop offset="100%" stopColor="rgba(245, 158, 11, 0.05)" />
          </linearGradient>
          
          <linearGradient id="dangerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="rgba(239, 68, 68, 0.2)" />
            <stop offset="100%" stopColor="rgba(239, 68, 68, 0.05)" />
          </linearGradient>
          
          <filter id="glow">
            <feGaussianBlur stdDeviation="2"/>
          </filter>
        </defs>

        {/* Factory floor */}
        <rect width="740" height="320" fill="#1f2937"/>
        
        {/* Subtle grid - only in main area */}
        <defs>
          <pattern id="grid" width="30" height="30" patternUnits="userSpaceOnUse">
            <path d="M 30 0 L 0 0 0 30" fill="none" stroke="rgba(75, 85, 99, 0.2)" strokeWidth="1"/>
          </pattern>
        </defs>
        <rect width="740" height="320" fill="url(#grid)"/>

        {/* Safety Zones - repositioned for cameras */}
        
        {/* Danger Zone (left) */}
        <ellipse cx="120" cy="160" rx="70" ry="50" fill="url(#dangerGrad)" stroke="#ef4444" strokeWidth="3" strokeDasharray="4,2">
          <animate attributeName="stroke-opacity" values="0.8;1;0.8" dur="1s" repeatCount="indefinite"/>
        </ellipse>
        
        {/* Warning Zone (center) */}
        <ellipse cx="300" cy="160" rx="75" ry="55" fill="url(#warningGrad)" stroke="#f59e0b" strokeWidth="2" strokeDasharray="6,3">
          <animate attributeName="stroke-opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite"/>
        </ellipse>
        
        {/* Safe Zone (right) */}
        <ellipse cx="480" cy="160" rx="70" ry="50" fill="url(#safeGrad)" stroke="#10b981" strokeWidth="2" strokeDasharray="8,4">
          <animate attributeName="stroke-opacity" values="0.6;1;0.6" dur="3s" repeatCount="indefinite"/>
        </ellipse>

        {/* Work Areas */}
        <g transform="translate(120, 160)">
          <rect x="-35" y="-15" width="70" height="30" rx="4" fill="#374151" stroke="#ef4444" strokeWidth="2"/>
          <text x="0" y="0" textAnchor="middle" fill="#ef4444" fontSize="8" fontWeight="600">COMPLETION BAY</text>
          <text x="0" y="35" textAnchor="middle" fill="#ef4444" fontSize="7">Tools 1.2m | Posture Critical</text>
        </g>

        <g transform="translate(300, 160)">
          <rect x="-40" y="-15" width="80" height="30" rx="4" fill="#374151" stroke="#f59e0b" strokeWidth="2"/>
          <text x="0" y="0" textAnchor="middle" fill="#f59e0b" fontSize="8" fontWeight="600">PRIMARY ASSEMBLY</text>
          <text x="0" y="35" textAnchor="middle" fill="#f59e0b" fontSize="7">PPE ⚠ | Motion Risk ⚠</text>
        </g>

        <g transform="translate(480, 160)">
          <rect x="-35" y="-15" width="70" height="30" rx="4" fill="#374151" stroke="#10b981" strokeWidth="2"/>
          <text x="0" y="0" textAnchor="middle" fill="#10b981" fontSize="8" fontWeight="600">INTEGRATION BAY</text>
          <text x="0" y="35" textAnchor="middle" fill="#10b981" fontSize="7">PPE ✓ | Ergonomic ✓</text>
        </g>

        {/* AI Camera Systems - one per bay */}
        <g transform="translate(120, 50)">
          <rect x="-12" y="-6" width="24" height="12" rx="3" fill="#374151" stroke="#06b6d4" strokeWidth="2"/>
          <circle cx="0" cy="0" r="3" fill="#06b6d4">
            <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite"/>
          </circle>
          
          {/* Camera field of view */}
          <path d="M -8 6 L -80 90 L 80 90 L 8 6 Z" fill="rgba(6, 182, 212, 0.06)" opacity="0.6"/>
          
          <text x="0" y="-18" textAnchor="middle" fill="#06b6d4" fontSize="8" fontWeight="600">AI CAM</text>
        </g>

        <g transform="translate(300, 50)">
          <rect x="-12" y="-6" width="24" height="12" rx="3" fill="#374151" stroke="#06b6d4" strokeWidth="2"/>
          <circle cx="0" cy="0" r="3" fill="#06b6d4">
            <animate attributeName="opacity" values="0.7;1;0.7" dur="2.2s" repeatCount="indefinite"/>
          </circle>
          
          {/* Camera field of view */}
          <path d="M -8 6 L -80 90 L 80 90 L 8 6 Z" fill="rgba(6, 182, 212, 0.06)" opacity="0.6"/>
          
          <text x="0" y="-18" textAnchor="middle" fill="#06b6d4" fontSize="8" fontWeight="600">AI CAM</text>
        </g>

        <g transform="translate(480, 50)">
          <rect x="-12" y="-6" width="24" height="12" rx="3" fill="#374151" stroke="#06b6d4" strokeWidth="2"/>
          <circle cx="0" cy="0" r="3" fill="#06b6d4">
            <animate attributeName="opacity" values="0.7;1;0.7" dur="1.8s" repeatCount="indefinite"/>
          </circle>
          
          {/* Camera field of view */}
          <path d="M -8 6 L -80 90 L 80 90 L 8 6 Z" fill="rgba(6, 182, 212, 0.06)" opacity="0.6"/>
          
          <text x="0" y="-18" textAnchor="middle" fill="#06b6d4" fontSize="8" fontWeight="600">AI CAM</text>
        </g>

        {/* Status indicators */}
        <g transform="translate(120, 120)">
          <polygon points="0,-25 -6,-15 6,-15" fill="#ef4444">
            <animate attributeName="opacity" values="0.6;1;0.6" dur="0.8s" repeatCount="indefinite"/>
          </polygon>
          <text x="0" y="-18" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">⚠</text>
        </g>

        <g transform="translate(300, 120)">
          <polygon points="0,-25 -6,-15 6,-15" fill="#f59e0b">
            <animate attributeName="opacity" values="0.6;1;0.6" dur="2s" repeatCount="indefinite"/>
          </polygon>
          <text x="0" y="-18" textAnchor="middle" fill="#1f2937" fontSize="8" fontWeight="bold">!</text>
        </g>

        <g transform="translate(480, 120)">
          <circle cx="0" cy="-20" r="5" fill="#10b981">
            <animate attributeName="opacity" values="0.8;1;0.8" dur="3s" repeatCount="indefinite"/>
          </circle>
          <text x="0" y="-17" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">✓</text>
        </g>

        {/* Analytics Panel - top center */}
        <g transform="translate(300, 25)">
          <rect x="-140" y="-15" width="280" height="30" rx="6" fill="rgba(30, 41, 59, 0.95)" stroke="rgba(71, 85, 105, 0.6)" strokeWidth="1"/>
          
          {/* Main KPIs */}
          <text x="-100" y="-5" fill="#10b981" fontSize="9" fontWeight="600">Safe: 1</text>
          <text x="-40" y="-5" fill="#f59e0b" fontSize="9" fontWeight="600">RSI Risk: 1</text>
          <text x="20" y="-5" fill="#ef4444" fontSize="9" fontWeight="600">Danger: 1</text>
          <text x="80" y="-5" fill="#06b6d4" fontSize="9" fontWeight="600">AI: 94%</text>
          
          <text x="0" y="8" textAnchor="middle" fill="#06b6d4" fontSize="8">MotionLogic® Safety AI</text>
        </g>

        {/* Right Column - Monitoring Panels */}
        
        {/* Joint Tracking */}
        <g transform="translate(680, 80)">
          <rect x="-50" y="-30" width="100" height="60" rx="4" fill="rgba(30, 41, 59, 0.9)" stroke="rgba(71, 85, 105, 0.5)" strokeWidth="1"/>
          <text x="0" y="-20" textAnchor="middle" fill="#10b981" fontSize="9" fontWeight="600">Joint Track</text>
          
          {/* Worker figure */}
          <circle cx="0" cy="-5" r="3" fill="none" stroke="#10b981" strokeWidth="1"/>
          <line x1="0" y1="-2" x2="0" y2="8" stroke="#10b981" strokeWidth="1"/>
          <line x1="0" y1="2" x2="-8" y2="10" stroke="#10b981" strokeWidth="1"/>
          <line x1="0" y1="2" x2="8" y2="10" stroke="#10b981" strokeWidth="1"/>
          <line x1="0" y1="8" x2="-6" y2="18" stroke="#10b981" strokeWidth="1"/>
          <line x1="0" y1="8" x2="6" y2="18" stroke="#10b981" strokeWidth="1"/>
          
          {/* Joint stress indicators */}
          <circle cx="-8" cy="10" r="1.5" fill="#f59e0b" opacity="0.8"/>
          <circle cx="8" cy="10" r="1.5" fill="#10b981" opacity="0.8"/>
          <circle cx="-6" cy="18" r="1.5" fill="#f59e0b" opacity="0.8"/>
          <circle cx="6" cy="18" r="1.5" fill="#10b981" opacity="0.8"/>
          
          {/* Angle measurement */}
          <path d="M -5,2 A 3,3 0 0,1 -8,5" fill="none" stroke="#f59e0b" strokeWidth="1"/>
          <text x="-20" y="8" fill="#f59e0b" fontSize="6">47°</text>
          
          <text x="0" y="25" textAnchor="middle" fill="#f59e0b" fontSize="7">High Fatigue Detected</text>
        </g>

        {/* Motion Chart */}
        <g transform="translate(680, 160)">
          <rect x="-50" y="-25" width="100" height="50" rx="4" fill="rgba(30, 41, 59, 0.9)" stroke="rgba(71, 85, 105, 0.5)" strokeWidth="1"/>
          <text x="0" y="-15" textAnchor="middle" fill="#06b6d4" fontSize="9" fontWeight="600">Motion Chart</text>
          
          {/* Chart axes */}
          <line x1="-40" y1="15" x2="40" y2="15" stroke="rgba(75, 85, 99, 0.5)" strokeWidth="1"/>
          <line x1="-40" y1="15" x2="-40" y2="-5" stroke="rgba(75, 85, 99, 0.5)" strokeWidth="1"/>
          
          {/* Motion path data */}
          <path d="M -35,10 Q -20,5 -5,8 Q 10,12 25,6 Q 35,14" fill="none" stroke="#06b6d4" strokeWidth="2"/>
          
          {/* Current position indicator */}
          <circle cx="35" cy="14" r="2" fill="#06b6d4">
            <animate attributeName="opacity" values="0.6;1;0.6" dur="2s" repeatCount="indefinite"/>
          </circle>
          
          {/* Stress indicators on chart */}
          <circle cx="-5" cy="8" r="1.5" fill="#f59e0b"/>
          <circle cx="25" cy="6" r="1.5" fill="#f59e0b"/>
          
          <text x="0" y="20" textAnchor="middle" fill="#9ca3af" fontSize="7">Joint Tracking</text>
        </g>

        {/* RSI Monitor */}
        <g transform="translate(680, 240)">
          <rect x="-50" y="-25" width="100" height="50" rx="4" fill="rgba(30, 41, 59, 0.9)" stroke="rgba(71, 85, 105, 0.5)" strokeWidth="1"/>
          <text x="0" y="-15" textAnchor="middle" fill="#f59e0b" fontSize="9" fontWeight="600">RSI Monitor</text>
          
          <line x1="-40" y1="15" x2="40" y2="15" stroke="rgba(75, 85, 99, 0.5)" strokeWidth="1"/>
          <line x1="-40" y1="15" x2="-40" y2="-5" stroke="rgba(75, 85, 99, 0.5)" strokeWidth="1"/>
          
          <polyline points="-35,10 -20,5 -5,8 10,12 25,6 35,14" fill="none" stroke="#f59e0b" strokeWidth="2"/>
          
          <circle cx="35" cy="14" r="2" fill="#f59e0b">
            <animate attributeName="opacity" values="0.6;1;0.6" dur="1.5s" repeatCount="indefinite"/>
          </circle>
          
          <text x="0" y="20" textAnchor="middle" fill="#9ca3af" fontSize="7">High Activity</text>
        </g>

        {/* Alert Banners - bottom area only */}
        <g transform="translate(150, 280)">
          <rect x="-40" y="-12" width="80" height="24" rx="4" fill="rgba(245, 158, 11, 0.9)" stroke="#f59e0b" strokeWidth="1">
            <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite"/>
          </rect>
          <text x="0" y="-3" textAnchor="middle" fill="white" fontSize="8" fontWeight="600">PROXIMITY ALERT</text>
          <text x="0" y="6" textAnchor="middle" fill="white" fontSize="7">1.2m from Tools</text>
        </g>
        
        <g transform="translate(450, 280)">
          <rect x="-50" y="-12" width="100" height="24" rx="4" fill="rgba(239, 68, 68, 0.9)" stroke="#ef4444" strokeWidth="1">
            <animate attributeName="opacity" values="0.8;1;0.8" dur="1.5s" repeatCount="indefinite"/>
          </rect>
          <text x="0" y="-3" textAnchor="middle" fill="white" fontSize="8" fontWeight="600">PPE MISSING</text>
          <text x="0" y="6" textAnchor="middle" fill="white" fontSize="7">Safety Glasses Required</text>
        </g>
      </svg>
    </div>
  );
};

export default SafetyVisualization;